import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { SuccessPopUp } from "../SuccessPopUp";


function ChangePass() {

    const navigate = useNavigate();

    const token = sessionStorage.getItem('tokenKey');

    // Array for storing image previews
    const BASE_URL = process.env.REACT_APP_PP_URL;

    const [oldPassword, setOldPassword] = useState();
    const [newPassword, setNewPassword] = useState();

    const item = async () => {
        try {
            const res = await fetch(`${BASE_URL}/ops/v1/common-user/change-password`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    oldPassword: oldPassword,
                    newPassword: newPassword
                })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAction("Password updated Successfully");
                setShow(true);
            } else {
                setAction(getRes?.message);
                setShow(true);
            }
        } catch (e) {
            console.log(e, "error in change padss apij");
            setAction("something went wrong !");
            setShow(true);
        }
    };

    const [show, setShow] = useState(false);
    const [action, setAction] = useState();

    const onClose = () => {
        setShow(false);
        navigate(-1);
    };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Password Change</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="add-form">
                        <div className="add w-100 m-b2">
                            <label>Old Password</label>
                            <input
                                type="text"
                                name="title"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                        </div>

                        <div className="add w-100 m-b2">
                            <label>New Password</label>
                            <input
                                type="text"
                                name="title"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                        </div>

                    </div>

                    <div className="btn submit-btn">
                        <button onClick={() => { item() }}>Change Password</button>
                    </div>

                </div>
            </div>

            <SuccessPopUp
                isOpen={show}
                action={action}
                FutherMore={"ok"}
                onClose={onClose}
            />
        </>
    )
}
export { ChangePass }